module.exports = __webpack_public_path__ + "img/1.3157cd47.jpg";